import { useEffect } from 'react'
import { X } from 'lucide-react'

// Painel deslizante da direita (slide-over) reutilizável: detalhe de item e formulários.
// Fecha por Esc, clique no scrim e botão X; trava o scroll do body enquanto aberto.
export default function Drawer({ open, onClose, title, subtitle, icon, width = 'w-[28rem]', children, footer }) {
  useEffect(() => {
    if (!open) return
    const onKey = (e) => { if (e.key === 'Escape') onClose?.() }
    document.addEventListener('keydown', onKey)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prev
    }
  }, [open, onClose])

  return (
    <div className={`fixed inset-0 z-50 ${open ? '' : 'pointer-events-none'}`} aria-hidden={!open}>
      <div
        className={`absolute inset-0 bg-slate-900/30 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0'}`}
        onClick={onClose}
      />
      <div
        role="dialog"
        aria-modal="true"
        className={`absolute top-0 right-0 h-full ${width} max-w-[94vw] bg-white dark:bg-slate-900 shadow-2xl border-l border-slate-200 dark:border-slate-700 flex flex-col transition-transform duration-300 ${open ? 'translate-x-0' : 'translate-x-full'}`}
      >
        <div className="flex items-start justify-between gap-3 px-5 py-4 border-b border-slate-200 dark:border-slate-700 shrink-0">
          <div className="flex items-center gap-3 min-w-0">
            {icon}
            <div className="min-w-0">
              {title && <h2 className="font-semibold text-slate-800 dark:text-slate-100 truncate leading-tight">{title}</h2>}
              {subtitle && <p className="text-xs text-slate-500 dark:text-slate-400 truncate">{subtitle}</p>}
            </div>
          </div>
          <button onClick={onClose} className="text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300 shrink-0" aria-label="Fechar">
            <X size={18} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto scrollbar-thin">{children}</div>

        {footer && <div className="border-t border-slate-200 dark:border-slate-700 px-5 py-3 shrink-0 bg-white dark:bg-slate-900">{footer}</div>}
      </div>
    </div>
  )
}
